import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { useUserAuthStore } from 'src/stores/user/auth'

export const useSiteInfoStore = defineStore('siteInfo', () => {
  const siteInfo = ref(null)
  const currencyList = ref(null)
  const defaultCurrency = ref({
    code: 'KZT',
  })
  const seoData = ref(null)

  const getCountryCode = computed(() => {
    return useUserAuthStore().getUserRegion ? useUserAuthStore().getUserRegion : siteInfo.value.region
  })
  const userCurrency = computed(() => {
    return useUserAuthStore().user?.currency
  })

  const getCurrency = computed(() => {
    return useUserAuthStore().getUserCurrency ? useUserAuthStore().getUserCurrency : defaultCurrency.value
  })
  const getCurrencyCode = computed(() => {
    return getCurrency.value.code
  })

  const getMainDomain = computed(() => {
    return siteInfo.value?.mainDomain ?? null
  })
  const autoAcceptRules = computed(() => {
    return siteInfo.value?.autoAcceptRules ?? false
  })

  const isWebView = computed(() => {
    if (process.env.WEBVIEW === '1') {
      return true
    }
    return siteInfo.value?.isWebview ?? false
  })
  const getCurrentDomain = computed(() => {
    return siteInfo.value?.domain ?? null
  })
  const getMetaTitle = computed(() => {
    return seoData.value?.metaTitle ?? null
  })

  const getMetaDescription = computed(() => {
    return seoData.value?.metaDescription ?? null
  })
  const getSeoDescription = computed(() => {
    return seoData.value?.seoText ?? null
  })
  const getUserIp = computed(() => {
    return siteInfo.value?.realIp ?? null
  })
  const getRegion = computed(() => {
    return siteInfo.value?.region ?? null
  })
  const getRealRegion = computed(() => {
    return siteInfo.value?.realRegion ?? null
  })
  const getAvailableRegions = computed(() => {
    return siteInfo.value?.availableRegions ?? null
  })
  const getShowDocNum = computed(() => {
    return siteInfo.value?.showDocNum ?? null
  })
  const getFullCheck = computed(() => {
    return siteInfo.value?.fullCheck
  })

  // useSiteInfoStore()

  function updateSiteInfo(payload) {
    siteInfo.value = payload
    if (payload?.isWebview) {
      document.querySelector('body').classList.add('web-view')
    }
  }

  function updateSeoData(payload) {
    seoData.value = payload
  }

  function updateFullCheck(payload) {
    if (siteInfo.value) {
      siteInfo.value = { ...siteInfo.value, fullCheck: payload }
    }
  }

  function setCurrencyData(payload) {
    currencyList.value = payload.currencies
    defaultCurrency.value = payload.defaultCurrency
  }

  function findCurrencyCodeById(payload) {
    return currencyList.value?.find((currency) => currency.objId === payload)?.code || defaultCurrency.value?.code
  }

  return {
    // refs
    siteInfo,
    currencyList,
    defaultCurrency,
    seoData,
    // computed
    getCountryCode,
    getCurrency,
    getCurrencyCode,
    getMainDomain,
    autoAcceptRules,
    isWebView,
    getCurrentDomain,
    getMetaTitle,
    getMetaDescription,
    getSeoDescription,
    getUserIp,
    getRegion,
    getRealRegion,
    getAvailableRegions,
    getShowDocNum,
    getFullCheck,
    userCurrency,
    //functions
    updateSiteInfo,
    updateSeoData,
    setCurrencyData,
    updateFullCheck,
    findCurrencyCodeById,
  }
})
